export const productAPIs = {
  add: {
    url: 'product',
    method: 'post',
    isAuthEnabled: true,
  },
  get: {
    url: 'product',
    method: 'get',
    isAuthEnabled: true,
  },
  delete: {
    url: 'product',
    method: 'delete',
    isAuthEnabled: true,
  },
  update: {
    url: 'product',
    method: 'patch',
    isAuthEnabled: true,
  },
};
